export default "/_nuxt/6f74361502d5faaa14acfdeefc0f7a42.svg";